<template>
  <div>
    <h1 class="title">Presentaci il tuo amico peloso</h1>

    <form class="form" @submit.prevent>
      <div class="form-group">
        <label class="form-label important-label">
          Ti ricordi esattamente quando è {{ sex == 1 ? "nato" : "nata" }}
          {{ dogData.name | capitalize }}?
        </label>
        <div
          class="switch-container"
          :class="[dog.hasBirthDate == null ? 'switch-empty' : '']"
        >
          <label
            for="birth_date_yes"
            class="switch-option"
            :class="[dog.hasBirthDate == 1 ? 'active-option' : 'inactive-option']"
          >
            <input
              v-model.number="$v.dog.hasBirthDate.$model"
              class="hidden"
              type="radio"
              id="birth_date_yes"
              value="1"
            />
            <span>Sì</span></label
          >
          <label
            for="birth_date_no"
            class="switch-option"
            :class="[dog.hasBirthDate == 0 ? 'active-option' : 'inactive-option']"
          >
            <input
              v-model.number="$v.dog.hasBirthDate.$model"
              class="hidden"
              type="radio"
              id="birth_date_no"
              value="0"
            />
            <span>No</span></label
          >
        </div>
        <div v-if="$v.dog.hasBirthDate.$error" class="error">campo obbligatorio</div>
      </div>

      <div v-if="showBirthDate" class="form-group">
        <select
          :class="[this.year == '' ? 'text-gray-300' : '']"
          class="form-control mt-5"
          v-model="year"
        >
          <option value="">Anno</option>
          <option v-for="(year, index) in years" :value="year" :key="index">
            {{ year }}
          </option>
        </select>
        <select
          :class="[this.month == '' ? 'text-gray-300' : '']"
          class="form-control mt-10"
          v-model="month"
        >
          <option value="">Mese</option>
          <option
            v-for="(selectedMonth, index) in months"
            :value="index + 1"
            :key="index"
          >
            {{ selectedMonth }}
          </option>
        </select>
        <select
          :class="[this.day == '' ? 'text-gray-300' : '']"
          class="form-control mt-10"
          v-model="day"
        >
          <option value="">Giorno</option>
          <option v-for="n in days" :value="n" :key="n">{{ n }}</option>
        </select>
        <div class="hidden">
          <date-picker
            v-model="year"
            type="year"
            placeholder="Anno"
            value-type="YYYY"
            format="YYYY"
          ></date-picker>
          <!-- <div v-if="$v.dog.birthDate.$error" class="error">campo obbligatorio</div> -->
          <date-picker
            v-model="month"
            type="month"
            placeholder="Mese"
            value-type="MM"
            format="MMMM"
          ></date-picker>
          <!-- <div v-if="$v.dog.birthDate.$error" class="error">campo obbligatorio</div> -->
          <date-picker
            v-model="day"
            type="date"
            placeholder="Giorno"
            value-type="DD"
            format="D"
          ></date-picker>
        </div>
        <div v-if="$v.ageInMonths.$error && !$v.ageInMonths.minValue" class="error">
          Le pappe Real Bowl sono ideali dopo i 60 giorni di vita del tuo cucciolo. Per
          maggiore info
          <a :href="contactURL" target="_blank">contattaci</a>.
        </div>
      </div>

      <div v-if="showIsAdult" class="form-group">
        <label class="form-label"
          >{{ dogData.name | capitalize }} ha più di 11 mesi?</label
        >
        <div class="switch-container" :class="[dog.adult == null ? 'switch-empty' : '']">
          <label
            for="adult_yes"
            class="switch-option"
            :class="[dog.adult == 1 ? 'active-option' : 'inactive-option']"
          >
            <input
              v-model.number="$v.dog.adult.$model"
              class="hidden"
              type="radio"
              id="adult_yes"
              value="1"
            />
            <span>Sì</span></label
          >
          <label
            for="adult_no"
            class="switch-option"
            :class="[dog.adult == 0 ? 'active-option' : 'inactive-option']"
          >
            <input
              v-model.number="$v.dog.adult.$model"
              class="hidden"
              type="radio"
              id="adult_no"
              value="0"
            />
            <span>No</span></label
          >
        </div>
        <div v-if="$v.dog.adult.$error" class="error">campo obbligatorio</div>
      </div>

      <div v-if="showHowManyMonths" class="form-group">
        <label class="form-label" for="months">Quanti mesi ha?</label>
        <input
          v-model.number="$v.dog.months.$model"
          type="number"
          placeholder="Indica i mesi"
          min="2"
          max="11"
          class="form-control"
          id="months"
        />
        <div v-if="$v.dog.months.$error && !$v.dog.months.required" class="error">
          campo obbligatorio
        </div>
        <div v-if="$v.dog.months.$error && !$v.dog.months.minValue" class="error">
          Le pappe Real Bowl sono ideali dopo i 60 giorni di vita del tuo cucciolo. Per
          maggiore info
          <a :href="contactURL" target="_blank">contattaci</a>.
        </div>
        <div v-if="$v.dog.months.$error && !$v.dog.months.maxValue" class="error">
          inserire un valore compreso tra 2 e 11 mesi
        </div>
        <div class="additional-info">
          Non ti preoccupare se non ricordi il mese esatto, ci serve un'indicazione di
          massima per calibrare al meglio la sua porzione di cibo fresco
        </div>
      </div>
      <div v-if="dog.adult != null">
        <div class="form-group">
          <label class="form-label" for="dog_weight"
            >Quanto pesa
            <span class="text-2xl text-red-600">{{ question }}</span>
            {{ dogData.name | capitalize }}?</label
          >
          <div class="flex items-end">
            <input
              v-model.number="$v.dog.weight.$model"
              type="number"
              min="1"
              placeholder="Inserisci il peso"
              class="form-control"
              id="dog_weight"
            />&nbsp;kg
          </div>
          <div v-if="$v.dog.weight.$error && !$v.dog.weight.required" class="error">
            campo obbligatorio
          </div>
          <div v-else-if="$v.dog.weight.$error && !$v.dog.weight.minValue" class="error">
            inserire un valore uguale o superiore a 1 kg
          </div>
        </div>
        <div v-if="dog.adult != 1" class="additional-info">
          Conoscendo la stazza <u>dei suoi genitori</u> riusciremo a stimare il suo
          fabbisogno calorico durante la crescita; tuttavia è importante tenere osservato
          il tuo cucciolo ed eventualmente aggiustare il calcolo in base al suo sviluppo
          fisico.
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required, requiredIf, minValue, maxValue } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/it";

export default {
  components: { DatePicker },
  props: {
    wizardData: {
      type: Object,
      required: true,
    },
    dogData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sex: null,
      today: new Date(),
      months: [
        "Gennaio",
        "Febbraio",
        "Marzo",
        "Aprile",
        "Maggio",
        "Giugno",
        "Luglio",
        "Agosto",
        "Settembre",
        "Ottobre",
        "Novembre",
        "Dicembre",
      ],
      //  2  29gg
      //  3,6,9,11  30gg
      year: "",
      month: "",
      day: "",
      dog: {
        hasBirthDate: null,
        birthDate: null,
        months: null,
        adult: null,
        weight: null,
      },
      question: "",
      ageInMonths: 0,
      contactURL: this.$hostname + "/contatti",
    };
  },
  validations: {
    dog: {
      hasBirthDate: {
        required,
      },
      birthDate: {
        required: requiredIf(function () {
          return this.showBirthDate;
        }),
      },
      months: {
        required: requiredIf(function () {
          return this.showHowManyMonths;
        }),
        minValue: minValue(2),
        maxValue: maxValue(11),
      },
      adult: {
        required,
      },
      weight: {
        required,
        minValue: minValue(1),
      },
    },
    ageInMonths: {
      required: requiredIf(function () {
        return this.showBirthDate;
      }),
      minValue: minValue(2),
    },
    // month: {
    //   required
    // },
    // year: {
    //   required
    // }
  },
  computed: {
    years: function () {
      let currentYear = this.today.getFullYear();
      let yearsList = [];
      for (let index = 0; index < 19; index++) {
        const yearToAdd = currentYear - index;
        yearsList.push(yearToAdd);
      }

      return yearsList;
    },
    days: function () {
      let greaterDay = 31;
      if (2 == this.month) {
        greaterDay = 29;
      } else if (
        3 == this.month ||
        6 == this.month ||
        9 == this.month ||
        11 == this.month
      ) {
        greaterDay = 30;
      }

      return greaterDay;
    },
    showBirthDate: function () {
      return this.dog.hasBirthDate == 1;
    },
    showIsAdult: function () {
      return this.dog.hasBirthDate == 0;
    },
    showHowManyMonths: function () {
      return this.dog.adult == 0 && this.dog.hasBirthDate == 0;
    },
  },
  watch: {
    "dog.hasBirthDate": function (value) {
      if (value == "0") {
        this.dog.adult = null;
        this.year = "";
        this.month = "";
        this.day = "";
        this.ageInMonths = 0;
      }
    },
    "dog.adult": function (value) {
      if (value == 1) {
        this.dog.months = null;
        this.ageInMonths = 12;
      }
      this.questionText();
    },
    year: function (value) {
      if (value) {
        this.calculateAgeInMonths();
      }
    },
    month: function (value) {
      if (value) {
        this.calculateAgeInMonths();
      }
    },
    day: function (value) {
      if (value) {
        this.calculateAgeInMonths();
      }
    },
  },
  methods: {
    calculateAgeInMonths() {
      this.dog.adult = null;
      this.dog.months = null;

      let diffYear = this.today.getFullYear() - this.year,
        diffMonth = this.today.getMonth() + 1 - this.month,
        diffDays = this.today.getDate() - this.day;
      let months = diffYear * 12 + diffMonth;
      if (diffDays < 0) {
        months--;
      }
      if (months < 12) {
        this.dog.adult = 0;
        this.dog.months = months;
      } else {
        this.dog.adult = 1;
      }
      this.ageInMonths = months;
      this.$v.$touch();
    },
    setBirthDate() {
      let birthDate = null;
      if (this.year && this.month) {
        let day = !this.day ? "1" : this.day;
        // birthDate = this.year + "-" + this.month + "-" + day;
        birthDate = new Date(this.year, this.month - 1, day, 5, 24, 0);
        /* Javascript start months count from January 0 */
      } else if (this.dog.months) {
        let diffMonth = this.today.getMonth() + 1 - this.dog.months;
        if (diffMonth <= 0) {
          birthDate =
            this.today.getFullYear() -
            1 +
            "-" +
            ("00" + (12 + diffMonth)).slice(-2) +
            "-01";
        } else {
          birthDate =
            this.today.getFullYear() + "-" + ("00" + diffMonth).slice(-2) + "-01";
        }
        this.ageInMonths = this.dog.months;
      }
      this.dog.birthDate = birthDate;
    },
    submit() {
      this.$v.$touch();
      return new Promise((resolve, reject) => {
        this.setBirthDate();
        if (!this.$v.$invalid) {
          resolve({
            dog: {
              hasBirthDate: this.dog.hasBirthDate,
              birthDate: this.dog.birthDate,
              months: this.dog.months,
              adult: this.dog.adult,
              weight: this.dog.weight,
            },
          });
        } else {
          reject("invalid entry");
        }
      });
    },
    questionText() {
      this.question = "";
      if (this.dog.adult != 1) {
        this.question =
          this.sex == 1 ? "indicativamente il papà di " : "indicativamente la mamma di ";
      }
    },
  },
  activated() {
    this.sex = this.dogData.sex;
    this.dog.hasBirthDate = this.dogData.hasBirthDate;
    this.dog.months = this.dogData.months;
    this.dog.adult = this.dogData.adult;

    if (this.dogData.hasBirthDate) {
      var birthDate = new Date(this.dogData.birthDate);
      this.day = birthDate.getDate();
      this.month = birthDate.getMonth() + 1;
      this.year = birthDate.getFullYear();
      this.calculateAgeInMonths();
    } else {
      this.day = "";
      this.month = "";
      this.year = "";
    }
    this.questionText();
    this.dog.weight = this.dogData.weight;
    this.$v.$reset();
  },
  created() {
    this.questionText();
  },
};
</script>
